/** Слияние текущих query-параметров виджета с правками (сохраняет org_slug, branch_id, key, …). */
export function mergeWidgetQueryString(
  currentSearchWithoutQuestion: string,
  updates: Record<string, string | null | undefined>
): string {
  const p = new URLSearchParams(currentSearchWithoutQuestion.trim());
  for (const [k, v] of Object.entries(updates)) {
    if (v === undefined || v === null || v === '') {
      p.delete(k);
    } else {
      p.set(k, v);
    }
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}
